import script from "./breadCrumb.vue?vue&type=script&setup=true&name=breadCrumb&lang=js"
export * from "./breadCrumb.vue?vue&type=script&setup=true&name=breadCrumb&lang=js"

const __exports__ = script;

export default __exports__